import { createSelector } from 'reselect'

import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_AD_MANAGER_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../constants/selectLists/platformList'

// PLOP_APPEND_PATTERN_ANCHOR

// rights
export const rightsListSelector = createSelector(
  ({ rights }) => rights.rightsList.results,
  rightsList => rightsList
)

export const rightsListIsLoadingSelector = createSelector(
  ({ rights }) => rights.rightsList.isLoading,
  isLoading => isLoading
)

export const rightsListWasLoadedSelector = createSelector(
  ({ rights }) => rights.rightsList.wasLoaded,
  wasLoaded => wasLoaded
)

export const rightsListErrorSelector = createSelector(
  ({ rights }) => rights.rightsList.error,
  error => error
)

// get right
export const rightSelector = createSelector(
  ({ rights }) => rights.right.data,
  data => data
)

export const rightIsLoadingSelector = createSelector(
  ({ rights }) => rights.right.isLoading,
  isLoading => isLoading
)

export const rightWasLoadedSelector = createSelector(
  ({ rights }) => rights.right.wasLoaded,
  wasLoaded => wasLoaded
)

export const rightWasRefetchedSelector = createSelector(
  ({ rights }) => rights.right.wasRefetched,
  wasRefetched => wasRefetched
)

export const rightErrorSelector = createSelector(
  ({ rights }) => rights.right.error,
  error => error
)

// create right
export const createdRightIsLoadingSelector = createSelector(
  ({ rights }) => rights.createdRight.isLoading,
  isLoading => isLoading
)

export const rightWasCreatedSelector = createSelector(
  ({ rights }) => rights.createdRight.wasCreated,
  wasLoaded => wasLoaded
)

export const createdRightErrorSelector = createSelector(
  ({ rights }) => rights.createdRight.error,
  error => error
)

// update right
export const updateRightIdSelector = createSelector(
  ({ rights }) => rights.updateRight.id,
  id => id
)

export const updateRightIsLoadingSelector = createSelector(
  ({ rights }) => rights.updateRight.isLoading,
  isLoading => isLoading
)

export const updateRightErrorSelector = createSelector(
  ({ rights }) => rights.updateRight.error,
  error => error
)

export const updateRightWasUpdatedSelector = createSelector(
  ({ rights }) => rights.updateRight.wasUpdated,
  wasUpdated => wasUpdated
)

// delete right
export const deleteRightIdSelector = createSelector(
  ({ rights }) => rights.deleteRight.id,
  id => id
)
export const deleteRightIsLoadingSelector = createSelector(
  ({ rights }) => rights.deleteRight.isLoading,
  isLoading => isLoading
)

// Get right suggested changes
export const rightSuggestedChangesSelector = createSelector(
  ({ rights }) => rights.rightSuggestedChanges.data,
  data => data
)

export const rightSuggestedChangesIsLoadingSelector = createSelector(
  ({ rights }) => rights.rightSuggestedChanges.isLoading,
  isLoading => isLoading
)

export const rightSuggestedChangesErrorSelector = createSelector(
  ({ rights }) => rights.rightSuggestedChanges.error,
  error => error
)

export const rightSuggestedChangesWasLoadedSelector = createSelector(
  ({ rights }) => rights.rightSuggestedChanges.wasLoaded,
  wasLoaded => wasLoaded
)

// Apply right suggested changes
export const applyRightSuggestedChangesIsLoadingSelector = createSelector(
  ({ rights }) => rights.applyRightSuggestedChanges.isLoading,
  isLoading => isLoading
)

export const applyRightSuggestedChangesErrorSelector = createSelector(
  ({ rights }) => rights.applyRightSuggestedChanges.error,
  error => error
)

export const applyRightSuggestedChangesWasCreatedSelector = createSelector(
  ({ rights }) => rights.applyRightSuggestedChanges.wasCreated,
  wasCreated => wasCreated
)

// Get partnerbrain history
export const partnerbrainHistorySelector = createSelector(
  ({ rights }) => rights.partnerbrainHistory.results,
  results => results
)

export const partnerbrainHistoryIsLoadingSelector = createSelector(
  ({ rights }) => rights.partnerbrainHistory.isLoading,
  isLoading => isLoading
)

export const partnerbrainHistoryErrorSelector = createSelector(
  ({ rights }) => rights.partnerbrainHistory.error,
  error => error
)

export const partnerbrainHistoryWasLoadedSelector = createSelector(
  ({ rights }) => rights.partnerbrainHistory.wasLoaded,
  wasLoaded => wasLoaded
)

export const partnerbrainHistoryNextSelector = createSelector(
  ({ rights }) => rights.partnerbrainHistory.paging.next,
  next => next
)

// Get right social posts
export const rightSocialPostsSelector = createSelector(
  ({ rights }) => rights.rightSocialPosts.results,
  results => results
)

export const rightSocialPostsIsLoadingSelector = createSelector(
  ({ rights }) => rights.rightSocialPosts.isLoading,
  isLoading => isLoading
)

export const rightSocialPostsErrorSelector = createSelector(
  ({ rights }) => rights.rightSocialPosts.error,
  error => error
)

export const rightSocialPostsWasLoadedSelector = createSelector(
  ({ rights }) => rights.rightSocialPosts.wasLoaded,
  wasLoaded => wasLoaded
)

// right upload ad data

export const rightUploadAdDataCampaignSelector = platform =>
  createSelector(
    ({ rights }) => rights.rightUploadAdData[platform]?.campaign,
    campaign => campaign
  )

export const facebookRightUploadAdCampaignSelector = createSelector(
  ({ rights }) => rights.rightUploadAdData[FACEBOOK_PLATFORM].campaign,
  campaign => campaign
)

export const facebookRightUploadAdLineItemSelector = createSelector(
  ({ rights }) => rights.rightUploadAdData[FACEBOOK_PLATFORM].lineItem,
  lineItem => lineItem
)

export const googleRightUploadAdDataSelector = createSelector(
  ({ rights }) => rights.rightUploadAdData[GOOGLE_PLATFORM],
  data => data
)

export const tiktokRightUploadAdDataSelector = createSelector(
  ({ rights }) => rights.rightUploadAdData[TIKTOK_PLATFORM],
  data => data
)

export const dv360RightUploadAdDataSelector = createSelector(
  ({ rights }) => rights.rightUploadAdData[DV_360_PLATFORM],
  data => {
    return data
  }
)

export const gamRightUploadAdDataSelector = createSelector(
  ({ rights }) => rights.rightUploadAdData[GOOGLE_AD_MANAGER_PLATFORM],
  data => data
)
